'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.VALUE_ALL = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Checkboxes = require('./Checkboxes');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VALUE_ALL = exports.VALUE_ALL = 'internal-all-items';

var SelectMultiple = function (_PureComponent) {
	_inherits(SelectMultiple, _PureComponent);

	function SelectMultiple() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, SelectMultiple);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectMultiple.__proto__ || Object.getPrototypeOf(SelectMultiple)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hasBeenFocused: false }, _this.getItemFromValue = function (value) {
			var _this$props = _this.props,
			    dataset = _this$props.dataset,
			    optionAllLabel = _this$props.optionAllLabel;


			if (value === VALUE_ALL) return {
				value: VALUE_ALL,
				label: optionAllLabel
			};

			var ob = dataset.find(function (d) {
				return d.value.toString() === value.toString();
			});
			if (!ob) {
				console.error("[SelectMultiple] Value", value, "not found in dataset"); // eslint-disable-line
				return null;
			}

			return ob;
		}, _this.onChangeSelect = function (_ref2) {
			var value = _ref2.value;

			_this.onFocus();
			var _this$props2 = _this.props,
			    onChange = _this$props2.onChange,
			    selected = _this$props2.selected,
			    id = _this$props2.id,
			    addOptionAll = _this$props2.addOptionAll,
			    noneIsAll = _this$props2.noneIsAll;


			if (value === null || value === "") return null;

			var isFull = _this.isFull();
			var ob = _this.getItemFromValue(value);

			if (!ob) return null;

			var newSelected = void 0;
			if (value === VALUE_ALL) {
				// Clicked on "All" value
				if (!selected.includes(VALUE_ALL)) {
					// We've checked all, so we add it and only it
					newSelected = noneIsAll ? [] : [VALUE_ALL];
				}
			} else {
				// Check if value is already in selected values
				if (!selected.includes(ob.value)) {
					if (isFull) return;
					// Not in selected, we should add it
					newSelected = [].concat(_toConsumableArray(selected), [ob.value]);
				} else {
					// Already in selected, we should remove it
					newSelected = selected.filter(function (s) {
						return s !== ob.value;
					});
				}

				// We we have option "all" and other thing is checked, we remove it from dataset
				if (addOptionAll) {
					newSelected = newSelected.filter(function (s) {
						return s !== VALUE_ALL;
					});
				}
			}

			onChange({ item: ob, selected: newSelected, id: id, type: 'select-multiple' });
		}, _this.onFocus = function () {
			if (!_this.state.hasBeenFocused) _this.setState({ hasBeenFocused: true });
		}, _this.onTabPressed = function (e) {
			if (e.value !== null && e.value !== "") {
				e.event.event.preventDefault();
			}
		}, _this.isFull = function () {
			var _this$props3 = _this.props,
			    selected = _this$props3.selected,
			    maxOptions = _this$props3.maxOptions;

			return maxOptions > 0 && selected.length >= maxOptions;
		}, _this.generateDataSet = function () {
			var _this$props4 = _this.props,
			    dataset = _this$props4.dataset,
			    addOptionAll = _this$props4.addOptionAll,
			    noneIsAll = _this$props4.noneIsAll,
			    selected = _this$props4.selected,
			    optionAllLabel = _this$props4.optionAllLabel,
			    disabled = _this$props4.disabled;


			var isFull = _this.isFull();

			// Building dataset items
			var firstItem = addOptionAll ? [{
				value: VALUE_ALL,
				label: optionAllLabel,
				disabled: selected.length === 0 && noneIsAll || disabled,
				react: _react2.default.createElement(LabelAndCheckbox, {
					label: optionAllLabel,
					checked: selected.length === 0 && noneIsAll || selected.includes(VALUE_ALL),
					disabled: disabled
				})
			}] : [];

			var allItems = dataset.map(function (opt) {
				return {
					value: opt.value,
					label: opt.label,
					disabled: disabled || isFull && !selected.includes(opt.value),
					react: _react2.default.createElement(LabelAndCheckbox, {
						label: opt.react || opt.label,
						checked: selected.includes(opt.value),
						disabled: disabled || isFull && !selected.includes(opt.value)
					})
				};
			});

			return [].concat(firstItem, _toConsumableArray(allItems));
		}, _this.getLabel = function () {
			var _this$props5 = _this.props,
			    label = _this$props5.label,
			    dynamicLabel = _this$props5.dynamicLabel,
			    selected = _this$props5.selected,
			    optionAllLabel = _this$props5.optionAllLabel,
			    addOptionAll = _this$props5.addOptionAll,
			    noneIsAll = _this$props5.noneIsAll;

			if (!dynamicLabel) return label;

			if (selected.length === 0) {
				if (noneIsAll && addOptionAll) return optionAllLabel;
				return label;
			}

			if (selected.length === 1) {
				var s = selected[0];
				if (s === VALUE_ALL) return optionAllLabel;

				var ob = _this.getItemFromValue(selected[0]);
				return ob.label;
			}

			return dynamicLabel.replace('{0}', selected.length);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(SelectMultiple, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    className = _props.className,
			    selected = _props.selected,
			    hasSearch = _props.hasSearch,
			    required = _props.required,
			    errorRequiredText = _props.errorRequiredText,
			    disabled = _props.disabled,
			    defaultOptionLabel = _props.defaultOptionLabel,
			    shrink = _props.shrink,
			    onFocusOut = _props.onFocusOut,
			    size = _props.size,
			    sort = _props.sort,
			    pinned = _props.pinned,
			    labelAsOption = _props.labelAsOption,
			    labelAsPlaceholder = _props.labelAsPlaceholder;
			var hasBeenFocused = this.state.hasBeenFocused;


			var isFull = this.isFull();

			return _react2.default.createElement(
				'div',
				{ className: 'bnc_field bnc_field_select_multiple ' + className },
				_react2.default.createElement(_Select2.default, {
					value: '',
					required: required,
					defaultOptionLabel: defaultOptionLabel,
					label: this.getLabel(),
					controlledError: true,
					closeOnChange: false,
					dataset: this.generateDataSet(),
					error: hasBeenFocused && required && selected.length === 0,
					onTabPressed: this.onTabPressed,
					onChange: this.onChangeSelect,
					errorRequiredText: '',
					onFocus: this.onFocus,
					hasSearch: hasSearch,
					disabled: disabled,
					className: isFull ? "select--full" : "",
					shrink: shrink,
					onFocusOut: onFocusOut,
					size: size,
					sort: sort,
					pinned: pinned,
					labelAsOption: labelAsOption,
					labelAsPlaceholder: labelAsPlaceholder,
					closeOnBlur: false,
					isMultiple: true
				}),
				hasBeenFocused && required && selected.length === 0 && _react2.default.createElement(
					'span',
					{ className: 'error' },
					errorRequiredText
				)
			);
		}
	}]);

	return SelectMultiple;
}(_react.PureComponent);

var LabelAndCheckbox = (0, _react.memo)(function (_ref3) {
	var label = _ref3.label,
	    checked = _ref3.checked,
	    disabled = _ref3.disabled;
	return _react2.default.createElement(
		'div',
		{ className: 'bnc_field bnc_field_checkboxes' },
		_react2.default.createElement(_Checkboxes.Checkbox, {
			className: 'bnc_field_select_multiple checkbox',
			label: label,
			checked: checked,
			disabled: disabled,
			onChange: null
		})
	);
});

SelectMultiple.defaultProps = {
	defaultOptionLabel: '',
	disabled: false,
	required: false,
	placeholder: '',
	errorRequiredText: 'This field is required',
	label: '',
	className: '',
	sort: true,
	pinned: [],
	selected: [],
	maxOptions: -1,
	hasSearch: false,
	noneIsAll: false,
	addOptionAll: false,
	optionAllLabel: '',
	shrink: true,
	dynamicLabel: null,
	onFocusOut: null,
	size: "regular",
	labelAsOption: false
};

SelectMultiple.propTypes = {
	id: _propTypes2.default.string,
	selected: _propTypes2.default.arrayOf(_utils.StringOrNumber).isRequired,
	dataset: _propTypes2.default.arrayOf(_propTypes2.default.shape({
		value: _utils.StringOrNumber.isRequired,
		label: _utils.StringOrReact.isRequired,
		react: _utils.StringOrReact,
		icon: _propTypes2.default.element,
		disabled: _propTypes2.default.bool
	})).isRequired,
	onChange: _propTypes2.default.func,
	pinned: _propTypes2.default.arrayOf(_utils.StringOrNumber),
	disabled: _propTypes2.default.bool,
	required: _propTypes2.default.bool,
	placeholder: _propTypes2.default.string,
	defaultOptionLabel: _propTypes2.default.string,
	errorRequiredText: _utils.StringOrReact,
	label: _utils.StringOrReact,
	className: _propTypes2.default.string,
	sort: _propTypes2.default.bool,
	size: _propTypes2.default.string,
	maxOptions: _propTypes2.default.number,
	hasSearch: _propTypes2.default.bool,
	noneIsAll: _propTypes2.default.bool,
	shrink: _propTypes2.default.bool,
	dynamicLabel: _propTypes2.default.string,
	addOptionAll: _propTypes2.default.bool,
	optionAllLabel: _utils.StringOrReact,
	onFocusOut: _propTypes2.default.func,
	labelAsOption: _propTypes2.default.bool
};

exports.default = SelectMultiple;